<template>
  <img class="purifier_img" :src="purifier.getImg()" />
</template>

<script>
export default {
  name: 'PurifierImage',
  props: {
    purifier: Object
  }
}
</script>

<style>
img.purifier_img {
  max-width:200px;
}
</style>



// WEBPACK FOOTER //
// src/components/PurifierImage.vue